 import React, { useRef, useEffect, useState } from "react";
 import Dialog from "@material-ui/core/Dialog";
 
 import DialogContent from "@material-ui/core/DialogContent";
 import DialogTitle from "@material-ui/core/DialogTitle";
 import "./NewPreviewModal.scss";
 import IconButton from "@material-ui/core/IconButton";
 import { PreviewEndPoint } from "../../services/axiosConfig";
 // import CloseIcon from "@material-ui/icons/Close";
 import Refresh from "../../images/Refresh.svg";
 import NewSlideRightArrowIcon from "../../images/Preview-Right-Arrow.svg";
 // import NewSlideLeftArrowIcon from "../../images/Preview-Left-Arrow.svg";
 import CancelIcon from "../../images/CancelIcon.svg";
 import previewDownArrow from "../../images/edetail-v-down.svg";
 import previewUpArrow from "../../images/edetail-v-up.svg";
 import previewRightArrow from "../../images/edetail-h-r.svg";
 import previewLeftArrow from "../../images/edetail-h-l.svg";
 import expiredRestrictedIcon from "../../images/expired-restriction-icon.svg";
 import EnabledRightArrowIcon from "../../images/EnabledRightArrowIcon.svg";
 import ActivePreviousIcon from "../../images/ActivePreviousIcon.svg";
 import DeactiveNextIcon from "../../images/DeactiveNextIcon.svg";
 import DesabledRightArrowIcon from "../../images/EnabledRightArrowIcon.svg";
 import EnabledLeftArrowIcon from "../../images/EnabledRightArrowIcon.svg";
 import DesabledLeftArrowIcon from "../../images/DesabledLeftArrowIcon.svg";
 import IPadIcon from "../../images/IPadIcon.svg";
 import DesktopIcon from "../../images/DesktopIcon.svg";
 import { convertInDate } from "../../utils";
 import CircularProgressBar from "../../utils/CircularProgressBar";
 import BaseModal from "../BaseModal/BaseModal";
 import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
 import { Slide } from "@material-ui/core";
 import { showWarningToast } from "../toastComponent/ToastComponent";
import { toast } from "react-toastify";
import DownArrowIcon from "../../images/DownArrowIcon.svg";
 
 export default function NewPreviewModal({
   showPreview,
   setShowPreView,
   setLoading,
   deckData,
   slideID,
   currentSlide,
   lastChild,
   inParent,
   appData,
   previewLoading,
   previewUrlReady = false,
   selectedItem,
   setScaleCentPercent
 }) {
   const [currentURL, SetCurrentURL] = React.useState(null);
   const [view, setView] = React.useState("iPad");
   const [slideName, setSlideName] = useState("");
   const [slideIndex, setSlideIndex] = useState(currentSlide?.master?.index);
   const [previewCurrentSlide, setPreviewCurrentSlide] = React.useState({
     master: slideID[0],
     child: {},
   });
   const iframeRef = useRef(null); 
   const [resolution, setResolution] = useState([
     {
       size: "1024*768",
       scale: 0.557,
     },
     {
       size: "2048*1536",
       scale: 0.279,
     },
     {
       size: "2388*1668",
       // scale: 0.650023,
       scale: 556
     },
     {
       size: "2752*2064",
       scale: 0.537,
     },
     {
      size: "1280*720",
      scale: 0.557,
     },
     {
      size: "1920*1080",
      scale: 0.432
     },
   ]);
   const [selectedResolution, setSelectedResolution] = useState("1024*768");
   const menuRef = useRef(null);
   const buttonRef = useRef(null);
   const [showTooltip, setShowTooltip] = useState(false);
   const [viewportHeight, setViewportHeight] = useState(
    typeof window !== "undefined" ? window.innerHeight : 768,
   );
   const [resW, resH] = selectedResolution.split('*').map(Number);
   const containerW = view === 'iPad' ? 570 : 754;
   const containerH = Math.min(427, Math.max(291, viewportHeight - 252));
   const modalH = containerH + 29;
   const widthRatio = containerW / resW;
   const heightRatio = containerH / resH;
   const fitScale = Math.min(widthRatio, heightRatio);
   const offsetX = (containerW - resW * fitScale) / 2;
   const offsetY = (containerH - resH * fitScale) / 2;
   // const [canvasHeight, SetCanvasHeight] = React.useState(1);
   // const sectionElement = React.useCallback((ref) => {
   //   let canvasHeight = ref?.getBoundingClientRect().height / (768 + 100);
   //   SetCanvasHeight(canvasHeight > 1 ? 1 : canvasHeight);
   // }, []);
 
   React.useEffect(() => {
     // setPreviewCurrentSlide({ master: slideID[0], child: {} });
     setPreviewCurrentSlide({ master: currentSlide.master, child: {} });
     // setSelectedResolution(selectedItem?.split('_')[1]);

    const handleClickOutside = (e) => {
      if ( 
        menuRef?.current && 
        !menuRef?.current?.contains(e.target) && 
        buttonRef?.current && 
        !buttonRef?.current?.contains(e.target) 
      ) {
        setShowTooltip(false); // Close the menu if click is outside
      }
    };
    document.addEventListener("click", handleClickOutside);
    // Cleanup the event listener when component is unmounted
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
 
   // useEffect(() => {
   //    const position = slideID.findIndex(item => item.slideid?.name === slideName);
   //   setSlideIndex(previewCurrentSlide.master?.index);
   // }, []);
 
   // Use deckData.name as fallback if appData.deckId.name is not available
   let DeckName = (appData?.deckId?.name || deckData?.name || "").replace(
     / /g,
     "_",
   );
   // let DeckName = deckData?.name.replace(/ /g, "_");
 
   React.useEffect(() => {
     // Only set URL after API call completes successfully
     if (previewUrlReady && showPreview) {
       const user = localStorage?.getItem("userId") || "";
       appData["userSub"] = user;
       let SlideName = (currentSlide.master?.slideid?.name || "Slide1").replace(
         / /g,
         "_",
       );
       setSlideName(SlideName);
       // Ensure DeckName is not empty
       const finalDeckName =
         DeckName || (deckData?.name || "Deck").replace(/ /g, "_");
 
       SetCurrentURL(
         `${PreviewEndPoint}preview/${appData.userSub}/${finalDeckName}/${SlideName}/${SlideName}.html`,
       );
     } else {
       SetCurrentURL(null);
     }
   }, [previewUrlReady, showPreview]);
 
   // const handleCloseExport = () => {
   //   setShowPreView(false);
   //   // Reset URL when closing to prevent showing cached content on next open
   //   SetCurrentURL(null);
   // };
   const lastPage = () => {
     return slideID?.length > 0
       ? slideID[slideID.length - 1].slideid?._id ===
           previewCurrentSlide.master.slideid?._id
       : false;
   };
 
   const firstPage = () => {
     return slideID?.length > 0
       ? slideID[0].slideid?._id === previewCurrentSlide?.master?.slideid?._id
       : false;
   };
   const handleParent = () => {
     let nextIndex = previewCurrentSlide.master?.index;
     setSlideIndex(nextIndex + 1);
     if (nextIndex === slideID.length) return;
     setPreviewCurrentSlide({
       master: slideID[nextIndex],
       child: {},
     });
     let slidename = slideID[nextIndex].slideid.name.replace(/ /g, "_");
 
     const deckName = (
       appData?.deckId?.name ||
       deckData?.name ||
       "Deck"
     ).replace(/ /g, "_");
     SetCurrentURL(
       `${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${slidename}/${slidename}.html`,
     );
   };
   const gotoPrevious = () => {
     let prevIndex = previewCurrentSlide?.master?.index - 2;
     let previousIndex = previewCurrentSlide.master?.index;
 
     if (prevIndex < 0) return;
     setSlideIndex(previousIndex - 1);
     setPreviewCurrentSlide({
       master: slideID[prevIndex],
       child: {},
     });
     let slidename = (slideID[prevIndex]?.slideid?.name || "Slide1").replace(
       / /g,
       "_",
     );
 
     const deckName = (
       appData?.deckId?.name ||
       deckData?.name ||
       "Deck"
     ).replace(/ /g, "_");
     SetCurrentURL(
       `${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${slidename}/${slidename}.html`,
     );
   };
 
   const handleChangeView = (val) => {
    if(val === "iPad"){
      setSelectedResolution("1024*768");
    } else if(val === "desktop") {
      setSelectedResolution("1920*1080");
    }
     setView(val);
   };

  let toastOpen  = false; // track last invalid number

  let activeToast = null;

const showWarningToastOnce = (message, headerMessage) => {
  if (activeToast !== null) return; // already a toast open

  activeToast = showWarningToast(message, headerMessage);

  // Listen for toast removal
  const unsubscribe = toast.onChange((toastEvent) => {
    if (toastEvent.id === activeToast && toastEvent.status === "removed") {
      activeToast = null; // reset for next toast
      unsubscribe(); // stop listening
    }
  });
};
  //  const inputHandler = (e) => {
  //   const val = e.target.value;

  //     // Allow empty (so user can delete)
  //   if (val === "") {
  //     setSlideIndex("");
  //     return;
  //   }

  //   // Allow only digits
  //   if (!/^\d+$/.test(val)) {
  //     return;
  //   }

  //   // Prevent first digit as 0
  //   if (val.length === 1 && val === "0") {
  //     return;
  //   }

  //   // Also block values like 01, 002 etc.
  //   if (val.startsWith("0")) {
  //     return;
  //   }
  //   //  if (!(slideID.length >= val)) {
  //   //    showWarningToast(
  //   //      `Please enter a slide number between 1 and ${slideID.length}`,
  //   //    );
  //   //    return;
  //   //  }
  //    const numericVal = parseInt(val, 10);
  // if (!(numericVal >= 1 && numericVal <= slideID.length)) {
  //   showWarningToastOnce(
  //     `Please enter a slide number between 1 and ${slideID.length}`
  //   );
  //   return;
  // }
  //    setSlideIndex(val);
  //    let nextIndex = val - 1;
  //    if (nextIndex === slideID.length) return;
  //    if (nextIndex >= 0) {
  //      setPreviewCurrentSlide({
  //        master: slideID[nextIndex],
  //        child: {},
  //      });
  //      let slidename = slideID[nextIndex].slideid.name.replace(/ /g, "_");
 
  //      const deckName = (
  //        appData?.deckId?.name ||
  //        deckData?.name ||
  //        "Deck"
  //      ).replace(/ /g, "_");
  //      SetCurrentURL(
  //        `${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${slidename}/${slidename}.html`,
  //      );
  //    }
  //  };

  const inputHandler = (e) => {
  const val = e.target.value;

  // Allow empty
  if (val === "") {
    setSlideIndex("");
    return;
  }

  // Allow only digits
  if (!/^\d+$/.test(val)) {
    return;
  }

  // Prevent leading zero
  if (val.length === 1 && val === "0") {
    return;
  }

  if (val.startsWith("0")) {
    return;
  }

  const numericVal = parseInt(val, 10);

  if (!(numericVal >= 1 && numericVal <= slideID.length)) {
    showWarningToastOnce(
      `Please enter a slide number between 1 and ${slideID.length}`
    );
    return;
  }

  // ✅ ONLY update state here (no navigation)
  setSlideIndex(val);
};

  const goToSlideFromInput = () => {
    if (!slideIndex) return;

    const numericVal = parseInt(slideIndex, 10);

    let nextIndex = numericVal - 1;
    if (nextIndex === slideID.length) return;

    if (nextIndex >= 0) {
      setPreviewCurrentSlide({
        master: slideID[nextIndex],
        child: {},
      });

      let slidename = slideID[nextIndex].slideid.name.replace(/ /g, "_");

      const deckName = (
        appData?.deckId?.name ||
        deckData?.name ||
        "Deck"
      ).replace(/ /g, "_");

      SetCurrentURL(
        `${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${slidename}/${slidename}.html`
      );
    }
  };

   const header = () => (
     <div
       className="preview-header d-flex align-items-center justify-content-between"
       style={{ width: "100%", padding: "20px" }}
     >
       <div
         className="d-flex align-items-center justify-content-between"
         style={{ width: "100%" }}
       >
         <div>
           <div className="preview-title">
             {appData?.deckId?.type == 1
               ? "Template Preview"
               : "e-Detail Preview"}
             {appData?.deckId?.expired && (
               <span className="expired-label-preview-popup">
                 <span className="expireIconStyles">
                   <img src={expiredRestrictedIcon} />
                 </span>
                 Expired
                 <span>
                   {convertInDate(
                     appData?.deckId?.expired_at
                       ? appData?.deckId?.expired_at
                       : "",
                     "normal",
                   )}
                 </span>
               </span>
             )}
           </div>
         </div>
         <div className="d-flex align-items-center justify-content-between">
            { !deckData.tags.includes("PDF_TO_HTML") && deckData.default_aspect_ratio && 
              <div className="drop-down-device-menu">
                <div
                  ref={buttonRef}
                  className="d-flex align-items-center"
                  onClick={() => setShowTooltip(pre => !pre)}
                  style={{ cursor: "pointer" }}
                >
                  <h3 className="" style={{borderBottom:"1px solid #E1E1E1", padding:3}}>{selectedResolution.replace("*", " x ")}</h3>
                  <img
                    className={showTooltip ? "expand-device-list" : ""}
                    src={DownArrowIcon}
                    alt=""
                  />
                </div>
                {showTooltip && (
                  <ul
                    ref={menuRef}
                    className="dropdown-device-list"
                    style={{ position: "absolute", zIndex: 2 }}
                  >
                    {resolution &&
                      resolution.filter(list => {
                        if(view === "iPad") {
                          return list?.size === "1024*768" || list?.size === "2048*1536" || list?.size === "2388*1668" || list?.size === "2752*2064";
                        } else {
                          return list?.size === "1280*720" || list?.size === "1920*1080";
                        }
                      })
                      .map((list, index) => (
                        <li
                          onClick={() => {
                            setSelectedResolution(list?.size);
                            setShowTooltip(false);
                          }}
                          className={list?.size === selectedResolution ? "selected-ratio" : ""}
                          style={{ cursor: "pointer" }}
                        >
                          {list?.size.replace("*", " x ")}
                          {list?.size === deckData?.default_aspect_ratio?.split("_")[1] ? " (Default)" : ""}
                        </li>
                      ))
                    }
                  </ul>
                )}
              </div>
            }
            {/* <div style={{background: "#d1e6e6", borderRadius: '6px', padding: "2px 9px 4px 9px"}}>
              <img src={IPadIcon} alt="" width={17} height={12} />
            </div> */}
           <ToggleButtonGroup
             type="radio"
             name="view-options"
             value={view}
             // style={{width: '64px', height: '26px'}}
             onChange={handleChangeView}
             className="border rounded-pill bg-light p1"
           >
             <ToggleButton
               id="tbg-radio-1"
               value="iPad"
               style={{
                 width: "32px",
                 backgroundColor: view === "iPad" ? "#D1E6E6" : "#ffffff",
               }}
               className={`${
                 view === "iPad" ? "active-ipad-btn" : "inActive-ipad-btn"
               } preview-ipad-btn rounded-pill border-0 px-3 d-flex align-items-center justify-content-center`}
             >
               <img src={IPadIcon} alt="" width={17} height={12} />
             </ToggleButton>
             <ToggleButton
               id="tbg-radio-2"
               value="desktop"
              //  disabled
               style={{
                 width: "32px",
                 backgroundColor: view === "desktop" ? "#D1E6E6" : "#ffffff",
               }}
               className={`${
                 view === "desktop"
                   ? "active-desktop-btn"
                   : "inActive-desktop-btn"
               } preview-desktop-btn rounded-pill border-0 px-3 d-flex align-items-center justify-content-center`}
             >
               <img src={DesktopIcon} alt="" width={17} height={12} />
             </ToggleButton>
           </ToggleButtonGroup>
         </div>
       </div>
     </div>
   );
 
   const footer = () => (
     <div className="nav-container">
       <div className="slide-controls">
         <img
           src={firstPage() ? DesabledLeftArrowIcon : ActivePreviousIcon}
           alt=""
           className="prev-btn"
           onClick={() => !firstPage() && gotoPrevious()}
           style={firstPage() ? {cursor: 'default'} : {cursor: 'pointer'}}
         />
         <div
           className="d-flex align-items-center justify-content-center"
           style={{ gap: "4px" }}
         >
           <span className="preview-slide-text">Slide</span>
           <input
             type="text"
             className="slide-input"
             onChange={inputHandler}
             onBlur={goToSlideFromInput}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                goToSlideFromInput();
              }
            }}
             value={slideIndex}
           />
           <span className="preview-slide-text">of {slideID?.length}</span>
         </div>
         <img
           src={lastPage() ? DeactiveNextIcon : EnabledRightArrowIcon}
           width="26"
           className="next-btn"
           alt=""
           style={lastPage() ? {cursor: 'default'} : {cursor: 'pointer'}}
           onClick={() => !lastPage() && handleParent()}
         />
       </div>
       <button className="close-btn" onClick={() => setShowPreView(false)}>
         CLOSE
       </button>
     </div>
   );
   //To handle the master to master linking in desktop
  useEffect(() => {
    function scrollContainerToTop(container) {
      if(!container) return;
      container.style.overflowY = "hidden";
      container.scrollTop = 0;

      requestAnimationFrame(() => {
        container.style.overflowY = "";
      });
    }
   
    const handler = (event) => {
      if (typeof event.data !== "string" || !event.data.startsWith("{")) return;
      const data = JSON.parse(event?.data);
      if (data?.action === "changeIframeSrc") {
        const deckName = ( appData?.deckId?.name || deckData?.name || "Deck" ).replace(/ /g, "_");
        const id = data.id;
        SetCurrentURL(`${PreviewEndPoint}preview/${appData.userSub}/${deckName}/${data?.src}/${data?.src}.html`);
        const index = slideID.find(ids => ids?.slideid?._id == id)?.index -1;
        if(index < 0) return;
        setSlideIndex(index+1);
        setPreviewCurrentSlide({master: slideID[index],child: {},});

        const iframe = document.querySelector(".preview-container");
        scrollContainerToTop(iframe);
      }
    };
   
    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("message", handler);
    };
  }, []);
  
   return (
     <>
       <BaseModal
         show={true}
         // onHide={() => setShow(false)}
         header={header()}
         footer={footer()}
         dialogClassName="card-preview-modal"
       >
         <div
           style={{
             width: view === 'iPad' ? `${offsetX > 20 ? "604px" : "644px"}` : `${offsetX > 20 ? "784px" : "824px"}`,
            height: `${modalH}px`,
             background: "#DDDFDD",
             borderRadius: "16px",
           }}
           className="d-flex align-items-center justify-content-center"
         >
           <div
             style={{
               width: view === 'iPad' ? `${offsetX > 20 ? "570px" : "610px"}` : `${offsetX > 20 ? "754px" : "794px"}`,
              height: `${containerH}px`,
               // height: "411px",
               background: "#fff",
               overflow: "hidden",
               position: "relative",
               borderRadius: "16px",
             }}
           >
             <CircularProgressBar
               isloading={previewLoading || !previewUrlReady}
             />
             {currentURL && previewUrlReady && (
               <iframe
                 title={"preview"}
                 // id="FrameID"
                 className="preview-iframe"
                 frameBorder="0"
                 key={selectedResolution}
                 ref={iframeRef}
                 src={currentURL}
                 onLoad={() => {
                   if (setLoading) {
                     setLoading(false);
                   }
                 }}
                 id="preview-iframe"
                style={{
                  position: "absolute",
                  width: `${resW}px`,
                  height: `${resH}px`,
                  transform: `scale(${fitScale})`,
                  left: `${offsetX > 20 ? offsetX : offsetX + 20}px`,
                  top: `${offsetY}px`,
                  transformOrigin: "top left",
                  border: "none",
                }}
               ></iframe>
             )}
           </div>
         </div>
         {/* <div className="preview-wrapper">
           <div className="preview-content">
             <CircularProgressBar
               isloading={previewLoading || !previewUrlReady}
             />
             {currentURL && previewUrlReady && (
               <iframe
                 title={"preview"}
                 // id="FrameID"
                 className="preview-iframe"
                 frameBorder="0"
                 key={currentURL}
                 src={currentURL}
                 onLoad={() => {
                   if (setLoading) {
                     setLoading(false);
                   }
                 }}
                 scrolling="no"
               ></iframe>
             )}
           </div>
         </div> */}
       </BaseModal>
       {/* <Dialog
         disableBackdropClick
         open={showPreview}
         onClose={() => setShowPreView(false)}
         className="preview exportAsModal"
         aria-labelledby="form-dialog-title"
         overlaystyle={{ backgroundColor: "transparent" }}
       >
         <div className="preview-dialog">
           <span>
             <span className="preview-title">
               {appData?.deckId?.type == 1
                 ? "Template Preview"
                 : "e-Detail Preview"}
               {appData?.deckId?.expired && (
                 <span className="expired-label-preview-popup">
                   <span className="expireIconStyles">
                     <img src={expiredRestrictedIcon} />
                   </span>
                   Expired
                   <span>
                     {convertInDate(
                       appData?.deckId?.expired_at
                         ? appData?.deckId?.expired_at
                         : "",
                       "normal"
                     )}
                   </span>
                 </span>
               )}
             </span>
             <span
               className="close-preview"
               onClick={() => setShowPreView(false)}
             >
               <img src={CancelIcon} alt="" className="preview-cancel-icon" />
             </span>
           </span>
         </div>
         <DialogContent style={{ padding: "0" }}>
           <div className="container-fulid previewModalVerticalMiddle">
             <div className="row g-0">
               <div className="col-md-12 d-flex">
                 {" "}
                 <div className="previewTopArrows">
                   <img
                     src={NewSlideRightArrowIcon}
                     className={
                       firstPage()
                         ? "disableNavigate left-icon"
                         : "preview-new-slide-left-icon left-icon"
                     }
                     alt=""
                     onClick={() => !firstPage() && gotoPrevious()}
                   />
                   <img
                     src={NewSlideRightArrowIcon}
                     width="26"
                     className={
                       lastPage()
                         ? "disableNavigate"
                         : "preview-new-slide-right-icon"
                     }
                     alt=""
                     onClick={() => !lastPage() && handleParent()}
                   />
                 </div>
               </div>
               <div className="col-md-12 text-center">
                 <div
                   className="preview-container customScrollBar"
                   style={{ position: "relative" }}
                 >
                   <CircularProgressBar
                     isloading={previewLoading || !previewUrlReady}
                   />
                   {currentURL && previewUrlReady && (
                     <iframe
                       title={"preview"}
                       id="FrameID"
                       className="preview-iframe"
                       frameBorder="0"
                       key={currentURL}
                       src={currentURL}
                       onLoad={() => {
                         if (setLoading) {
                           setLoading(false);
                         }
                       }}
                     ></iframe>
                   )}
                 </div>
               </div>
               <div className="col-md-12"></div>
             </div>
           </div>
         </DialogContent>
       </Dialog> */}
     </>
   );
 }